import * as aTypes from "./actionTypes";

// ============ LOGIN ============
export const initSessionActive = (session) => {
  return {
    type: aTypes.SESSION_INIT_ACTIVE,
    session: session,
  };
};

export const setSessionActive = (session, plans,isParentPaid, parentPermission, isParentActivityStatus=null,my_user=null) => {
  return {
    type: aTypes.SESSION_SET_ACTIVE,
    session,
    plans,
    isParentPaid,
    parentPermission,
    isParentActivityStatus,
    my_user
  };
};

export const setSessionActiveUser = (activeUser) => {
  return {
    type: aTypes.SESSION_SET_ACTIVE_USER,
    activeUser: activeUser,
  };
};

export const systemLoad = (sessionData) => {
  return {
    type: "SESSION_SYSTEM_LOAD",
    payload: sessionData,
  };
};

// ============ LOGOUT ============
export const resetSession = () => {
  return {
    type: aTypes.SESSION_RESET,
  };
};

export const initLogout = () => {
  return {
    type: aTypes.SESSION_LOGOUT,
  };
};

// ============ MY USER ============
export const initFetchMyUser = (user_id) => {
  return {
    type: aTypes.SESSION_USER_INIT,
    user_id: user_id,
  };
};

export const updateMyUser = (userData) => {
  return {
    type: aTypes.SESSION_UPDATE_MY_USER,
    userData: userData,
  };
};
